var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCoachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007676"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 1,
    y: 1,
    width: 5.625,
    height: 5.625,
    rx: 2,
    fill: "#68A14B",
    stroke: "#68A14B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 10.168,
    y: 1,
    width: 5.625,
    height: 5.625,
    rx: 2,
    fill: "#68A14B",
    stroke: "#68A14B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 1,
    y: 10.375,
    width: 5.625,
    height: 5.625,
    rx: 2,
    fill: "#68A14B",
    stroke: "#68A14B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 10.168,
    y: 10.375,
    width: 5.625,
    height: 5.625,
    rx: 2,
    fill: "#68A14B",
    stroke: "#68A14B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCoachIcon);
export default __webpack_public_path__ + "static/media/dashboard-coach-icon.df1a0d2e15fb02fc83b1c2f169de3cc7.svg";
export { ForwardRef as ReactComponent };